export default __webpack_public_path__ + "static/media/permeable-blog-2.97af3a3e.jpg";